import { useFormContext } from "react-hook-form";

import { ELEMENT_WRAPPER_MB, ElementWrapper, InputText, Label } from "@up/form";

export function StudentMiddleName({
  label = "Student Middle Name",
}: {
  label?: string;
}) {
  const { register } = useFormContext();
  const KEY = "student-middle-name";

  return (
    <ElementWrapper className={ELEMENT_WRAPPER_MB}>
      <Label htmlFor={KEY} text={label} />
      <InputText registerProps={register(KEY)} />
    </ElementWrapper>
  );
}
